let selectedDate = null;

$(document).ready(function ($) {
    $('.program-date-header').click(function () {
        if (selectedDate) {
            $(selectedDate).removeClass('selected');
            $('.schedule-' + $(selectedDate).data('day-id')).css('display', 'none');
        }

        selectedDate = this;

        $(this).addClass('selected');
        $('.schedule-' + $(this).data('day-id')).css('display', 'block');
    });

    if ($('.program-date-header').length > 0) {
        $('.program-date-header')[0].click();
    }

    $('#talk-description-modal').on('show.bs.modal', function (event) {
        const talk = $(event.relatedTarget).parent().parent();
        const modal = $(this);

        const data = talk.find('#modal-data').data('talk');
        const isBreak = talk.find('#modal-data').data('isbreak');

        const stream = talk.find('.stream-container');
        const nameAndLocation = talk.find('.talk-bottom-container');

        cleanPreviousModalContent(modal);

        modal.find('.modal-title').html(data.talk_title);
        modal.find('.talk-description').html(data.talk_desc);
        modal
            .find('.talk-difficulty')
            .html(
                "<span class='icon-difficulty me-2 align-self-center'></span> TECHNICAL DIFFICULTY: " +
                    data.talk_technical_difficulty
            );

        nameAndLocation.clone().appendTo(modal.find('.modal-title-stream'));
        appendBadgeToHeader(talk, stream, modal);
        toggleVideo(data, modal);
        toggleBody(isBreak, modal);
    });

    $('#talk-description-modal').on('hidden.bs.modal', function () {
        $(this)
            .find('.talk-video iframe')[0]
            .contentWindow.postMessage(
                '{"event":"command","func":"' + 'stopVideo' + '","args":""}',
                '*'
            );
    });
});

function cleanPreviousModalContent(modal) {
    modal.find('.modal-title-stream .stream-container').remove();
    modal.find('.modal-title-stream .talk-bottom-container').remove();
}

function appendBadgeToHeader(talk, stream, modal) {
    if (talk.find('.stream-container').length) {
        stream.clone().prependTo(modal.find('.modal-title-stream'));
    }
}

function toggleBody(isBreak, modal) {
    if (Boolean(isBreak)) {
        modal.find('.modal-body').hide();
    } else {
        modal.find('.modal-body').show();
    }
}

function toggleVideo(data, modal) {
    if (data.youtube_link) {
        modal.find('.talk-video iframe').attr('src', data.youtube_link);
        modal.find('.talk-video > div').removeClass('d-none');
        modal.find('.talk-video > p').addClass('d-none');
    } else {
        modal.find('.talk-video > div').addClass('d-none');
        modal.find('.talk-video > p').removeClass('d-none');
    }
}
